import { render, staticRenderFns } from "./BailiffCase.vue?vue&type=template&id=536391a8&"
import script from "./BailiffCase.vue?vue&type=script&lang=js&"
export * from "./BailiffCase.vue?vue&type=script&lang=js&"
import style0 from "./BailiffCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports